import React from 'react';
import { motion } from 'framer-motion';

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="bg-white shadow-[0_30px_60px_rgba(0,0,0,0.06)] grid grid-cols-1 lg:grid-cols-[1.1fr_1fr]">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, margin: '-100px' }}
          >
            <img
              src="/hed.JPG"
              alt="Every Detail, Thoughtfully Orchestrated"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, margin: '-100px' }}
            className="p-10 lg:p-14 flex flex-col justify-center"
          >
            <h3 className="text-3xl font-serif text-black mb-6 leading-tight">
              Every Detail, Thoughtfully Orchestrated
            </h3>
            <p className="text-sm text-gray-600 tracking-wide leading-relaxed mb-10">
              From the grandest vision to the smallest gesture, our team ensures nothing is left to chance – so your only task is to be present.
            </p>

            <motion.button
              whileHover={{ x: 5 }}
              className="inline-flex items-center gap-2 px-8 py-3 border border-black text-black uppercase tracking-[0.3em] text-[10px]"
            >
              Step Into the Experience
              <span className="text-xs">→</span>
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
